var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1861 5.84115C12.4976 4.3265 10.3184 3.49935 8.0003 3.49935C5.68222 3.49935 3.50301 4.3265 1.81454 5.84115L1.57857 5.60517C3.32735 4.02959 5.58684 3.16664 8.0003 3.16602L14.1861 5.84115ZM14.1861 5.84115L14.422 5.60517M14.1861 5.84115L14.422 5.60517M14.422 5.60517C12.6732 4.02946 10.4137 3.16604 8.00043 3.16602L14.422 5.60517ZM5.18264 9.79324L4.94588 9.55649C6.6971 8.1483 9.30351 8.1483 11.0547 9.55649L10.818 9.79324C9.19248 8.50427 6.80812 8.50427 5.18264 9.79324Z",
    fill: "#A5A5A8",
    stroke: "#A5A5A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0954 7.54151C5.85583 5.14241 10.1448 5.14241 12.9052 7.54151L12.6691 7.77762C10.0313 5.4986 5.96929 5.4986 3.33152 7.77762L3.0954 7.54151Z",
    fill: "#A5A5A8",
    stroke: "#A5A5A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83366 11.9993C8.83366 12.4596 8.46056 12.8327 8.00033 12.8327C7.54009 12.8327 7.16699 12.4596 7.16699 11.9993C7.16699 11.5391 7.54009 11.166 8.00033 11.166C8.46056 11.166 8.83366 11.5391 8.83366 11.9993Z",
    fill: "#A5A5A8",
    stroke: "#A5A5A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiIcon);
export default __webpack_public_path__ + "static/media/wifiIcon.c7aa20671222ab18fcd717eac1bde776.svg";
export { ForwardRef as ReactComponent };